import { render, staticRenderFns } from "./ElixioPayModuleMenu.vue?vue&type=template&id=06f1b18c&"
import script from "./ElixioPayModuleMenu.vue?vue&type=script&lang=js&"
export * from "./ElixioPayModuleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports